import { createWeb3Modal, defaultConfig } from "@web3modal/ethers5/react";
import { SONIC_CHAIN_ID, SONIC_RPC_URL } from "../blockchain/contracts";

// WalletConnect Project ID
const projectId = "fa1aadfb64b0750bfe31f23e8f986608";

// Sonic Chain Configuration
const sonicChain = {
    chainId: SONIC_CHAIN_ID,
    name: "Sonic",
    currency: "S",
    explorerUrl: "https://sonicscan.org",
    rpcUrl: SONIC_RPC_URL,
};

// Get the current URL for metadata (important for mobile wallet connections)
const getMetadataUrl = () => {
    if (typeof window !== "undefined") {
        return window.location.origin;
    }
    return "https://mcgpchain.com";
};

// Web3Modal metadata
const metadata = {
    name: "MCGP OTC Marketplace",
    description: "Buy and Sell MCGP tokens",
    url: getMetadataUrl(),
    icons: ["https://mcgpchain.com/mcgp-logo.png"],
};

// Ethers config
const ethersConfig = defaultConfig({
    metadata,
    enableEIP6963: true, // Enables injected wallets detection
    enableInjected: true, // Enables MetaMask, Trust Wallet, etc.
    enableCoinbase: true, // Enables Coinbase Wallet
    rpcUrl: SONIC_RPC_URL, // Fallback RPC for read operations
});

// Wallet IDs for featured wallets
const WALLET_IDS = {
    TRUST_WALLET: "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
    METAMASK: "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
    COINBASE: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
};

// Create Web3Modal instance
createWeb3Modal({
    ethersConfig,
    chains: [sonicChain],
    projectId,
    enableAnalytics: false,
    themeMode: "dark",
    themeVariables: {
        "--w3m-accent": "#8b5cf6",
        "--w3m-border-radius-master": "12px",
    },
    // Feature Trust Wallet for better mobile support
    featuredWalletIds: [
        WALLET_IDS.TRUST_WALLET,
        WALLET_IDS.METAMASK,
    ],
    includeWalletIds: [
        WALLET_IDS.TRUST_WALLET,
        WALLET_IDS.METAMASK,
        WALLET_IDS.COINBASE,
    ],
    enableOnramp: false,
    allWallets: "SHOW",
    features: {
        email: false,
        socials: false,
        emailShowWallets: false,
    },
    // Mobile wallet connection settings
    defaultChain: sonicChain,
});

export { projectId, sonicChain };
